<template>
  <drag-dialog
    :visible.sync="visible"
    custom-class="append-dialog"
    :title="`批量录入样品`"
    width="900px"
    height="450px"
    append-to-body
    :before-close="() => $emit('update:visible', false)"
    @close="$dialogFormReset('editForm')"
  >
    <el-form :model="editForm" :rules="rules" ref="editForm" label-width="120px">
      <el-row :gutter="20" type="flex" style="flex-wrap: wrap">
        <el-col :span="12">
          <el-form-item label="起始编号" prop="startNO">
            <el-input v-model.trim="editForm.startNO" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="样品数量" prop="addNumber">
            <el-input-number v-model="editForm.addNumber" :min="1"></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="试件名称" prop="sampleBelong">
            <el-input v-model.trim="editForm.sampleBelong" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="检测对象" prop="sampleName">
            <el-input v-model.trim="editForm.sampleName" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="试件型号" prop="model">
            <el-input v-model.trim="editForm.model" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="生产厂家" prop="manufacturer">
            <el-input v-model.trim="editForm.manufacturer" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12" v-if="hasHd">
          <el-form-item label="试件厚度" prop="shd">
            <el-input v-model.trim="editForm.shd" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item label="检测设备" prop="deviceNo">
            <el-input v-model.trim="editForm.deviceNo" placeholder="请输入" clearable></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="温度" prop="td">
            <el-input type="number" v-model="editForm.td" placeholder="请输入" clearable>
              <template slot="append">℃</template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="湿度" prop="wd">
            <el-input type="number" v-model="editForm.wd" placeholder="请输入" clearable>
              <template slot="append">%RH</template>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item label="试验日期" prop="testedTime">
            <el-date-picker
              v-model="editForm.testedTime"
              type="date"
              placeholder="选择日期"
              format="yyyy.MM.dd"
              value-format="yyyy.MM.dd"
              :clearable="false"
            ></el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <template slot="footer">
      <el-button @click="$emit('update:visible', false)">关 闭</el-button>
      <el-button type="primary" @click="handleSubmit">确 认</el-button>
    </template>
  </drag-dialog>
</template>

<script>
export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    hasHd: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      editForm: {
        startNO: '',
        addNumber: 1,
        sampleBelong: '',
        sampleName: '',
        model: '',
        manufacturer: '',
        shd: '',
        td: '',
        wd: '',
        deviceNo: '',
        testedTime: ''
      },
      rules: {
        sampleBelong: [{ required: true, trigger: 'blur', message: '请输入试件名称' }],
        sampleName: [{ required: true, trigger: 'blur', message: '请输入检测对象' }],
        td: [{ required: true, trigger: 'blur', message: '请输入温度' }],
        wd: [{ required: true, trigger: 'blur', message: '请输入湿度' }],
        testedTime: [{ required: true, trigger: 'change', message: '请选择试验日期' }]
      }
    };
  },
  watch: {
    visible(val) {
      if (val) {
      }
    }
  },
  methods: {
    handleSubmit() {
      this.$refs.editForm.validate(valid => {
        if (valid) {
          const { startNO, addNumber, sampleBelong, sampleName, model, manufacturer, shd, td, wd, testedTime, deviceNo } =
            this.editForm;

          const sampleOtherParams = {
            sampleBelong,
            sampleName,
            model,
            manufacturer,
            shd,
            td,
            wd,
            testedTime,
            deviceNo
          };

          const minStr = startNO.split('-').pop();
          const minNo = Number(minStr);
          const noPrefix = startNO.split('-').slice(0, -1).join('-');

          let addList = [];
          for (let i = 0; i < addNumber; i++) {
            const itemNo = `${noPrefix}-${(minNo + i).toString().padStart(3, '0')}`;
            addList.push({
              itemNo
            });
          }

          this.$emit('batchSampleAdd', addList, sampleOtherParams);
          this.$emit('update:visible', false);
        }
      });
    }
  },
  created() {},
  mounted() {}
};
</script>

<style lang="scss" scoped>
.el-select {
  width: 100%;
}
</style>
